export const ROOT = 'StepPayment/formPayment/payment';

export const SEND_DATA_PAYMENT_REQUEST = `${ROOT}/SEND_DATA_PAYMENT_REQUEST`;
export const SEND_DATA_PAYMENT_FAILURE = `${ROOT}/SEND_DATA_PAYMENT_FAILURE`;
export const SEND_DATA_PAYMENT_SUCCESS = `${ROOT}/SEND_DATA_PAYMENT_SUCCESS`;